(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stitchory-custom-product"] && !Shopify.designMode) return;
  try {
    
function initStCustom(root){
  if(root.dataset.initialized)return;
  root.dataset.initialized='true';
  const variants=JSON.parse(root.querySelector('[data-variants]').textContent);
  const config=JSON.parse(root.querySelector('[data-config]').textContent);
  const form=root.querySelector('form');
  const style=root.querySelector('[data-style]');
  const size=root.querySelector('[data-size]');
  const color=root.querySelector('[data-color]');
  const quantity=root.querySelector('[data-quantity]');
  const toggle=root.querySelector('[data-phrase-toggle]');
  const one=root.querySelector('[data-phrase-one]');
  const two=root.querySelector('[data-phrase-two]');
  const file=root.querySelector('[data-artwork]');
  const error=root.querySelector('[data-error]');
  const submit=root.querySelector('[data-submit]');
  const money=new Intl.NumberFormat(document.documentElement.lang||'en-CA',{style:'currency',currency:config.currency});
  const update=()=>{
    const styleName=style.value+(toggle.checked?' + phrase':'');
    const variant=variants.find(v=>v.option1===styleName&&v.option2===size.value&&v.option3===color.value);
    root.querySelector('[data-phrase-fields]').hidden=!toggle.checked;
    one.disabled=two.disabled=!toggle.checked;
    one.required=toggle.checked;
    submit.disabled=!variant||!variant.available;
    error.hidden=!!variant&&variant.available;
    error.textContent=error.hidden?'':config.unavailable;
    if(variant){
      root.querySelector('[data-variant-id]').value=variant.id;
      root.querySelector('[data-unit-price]').textContent=money.format(variant.price/100)+' '+config.currency;
      root.querySelector('[data-total]').textContent=money.format(variant.price*Math.max(1,Number(quantity.value)||1)/100)+' '+config.currency;
    }
  };
  [style,size,color,toggle,quantity].forEach(el=>el.addEventListener('input',update));
  [one,two].forEach(el=>el.addEventListener('input',()=>{el.value=el.value.replace(/[\r\n]+/g,' ');el.setCustomValidity(toggle.checked&&el===one&&!el.value.trim()?config.phrase_error:'');}));
  let previewUrl;
  file.addEventListener('change',()=>{
    file.setCustomValidity('');
    const image=file.files[0];
    const preview=root.querySelector('[data-art-preview]');
    if(previewUrl)URL.revokeObjectURL(previewUrl);
    preview.hidden=true;
    if(!image)return;
    if(!['image/png','image/jpeg','image/webp'].includes(image.type)||image.size>20*1024*1024){file.setCustomValidity(config.file_error);file.reportValidity();return;}
    previewUrl=URL.createObjectURL(image);preview.src=previewUrl;preview.hidden=false;
  });
  form.addEventListener('submit',event=>{
    update();
    one.setCustomValidity(toggle.checked&&!one.value.trim()?config.phrase_error:'');
    if(submit.disabled||!form.reportValidity())event.preventDefault();
  });
  const track=root.querySelector('.st-slides');
  const slides=[...track.children];
  const current=()=>Math.round(track.scrollLeft/track.clientWidth);
  const go=step=>{const index=(current()+step+slides.length)%slides.length;track.scrollTo({left:index*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
  root.querySelector('[data-prev]').addEventListener('click',()=>go(-1));
  root.querySelector('[data-next]').addEventListener('click',()=>go(1));
  track.addEventListener('scroll',()=>{root.querySelector('[data-slide-count]').textContent=(current()+1)+' / '+slides.length;},{passive:true});
  track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();go(event.key==='ArrowRight'?1:-1);}});
  update();
}
document.querySelectorAll('[data-st-custom]').forEach(initStCustom);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-st-custom]').forEach(initStCustom));

  } catch(e) { console.error(e); }
})();
})();
